define('modules/common/controller/ModalTestoMail',[], function() {
	var Controller = function(
		$scope,
		$modalInstance,
		fascicolohref,
		DettagliFascicolo) {

		$scope.closeModal = function() {
			$modalInstance.dismiss();
		};

		$scope.invia = function(){
			$modalInstance.close({
				testo:$scope.testo,
				hrefFascicolo:fascicolohref
			});
		};

		$scope.testo = "";

	};

	return [
		"$scope",
		"$modalInstance", 
		"fascicolohref",
		"DettagliFascicolo",
		Controller
	];
});
